
// jQuery('.Popover__ValueList button').click(function(){
//   console.log('hello');
// });


AOS.init({
	duration: 1000,
	startEvent: 'load',
	once: true,
});

window.addEventListener('load', AOS.refresh)

if ($(window).width() < 960) {
	var extraPadding = '100';
} else {
	var extraPadding = '150';
}

$('a[href*=\\#]:not([href$=\\#])').click(function(event) {
	event.preventDefault();
	$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top - extraPadding
	}, 500);
});


    //
		// Fade on link clicks
		setTimeout(function() {
			$('.main-content-wrapper, #shopify-section-footer').css('opacity', '1');
		}, 1510);

    var newLocation = '';

    $('.menu-item a').click(function() {
      newLocation = this.href;
      $('.main-content-wrapper, #shopify-section-footer').fadeOut(400, newPage);
		});

    function newPage() {
			window.location = newLocation;
    }



// fix for shopify theme editor
if ( window.location !== window.parent.location ) {

	$("[data-aos^=fade]").each(function() {
		$(this).addClass("aos-init aos-animate");
	});

	$('[data-aos^=fade]').css('opacity', '1');
	// The page is in an iframe
}

if($('.product-gallery').length) {
	var slideImages = $('.product-gallery--viewport--figure').length;

	if(slideImages <= '1') {
		$('.ico-right-arrow').addClass('hide');
		$('.ico-left-arrow').addClass('hide');
	}

	$(".ico-right-arrow").on( "click", function() {
		let current = $(".product-gallery--navigation").find(`[data-product-gallery-selected='true']`);
		$(current).next().trigger( "click" );
	});

	$(".ico-left-arrow").on( "click", function() {
		let current = $(".product-gallery--navigation").find(`[data-product-gallery-selected='true']`);
		$(current).prev().trigger( "click" );
	});

	$(".product-gallery--navigation button").on( "click", function() {
		let currentThumb = $(this).attr("data-product-gallery-thumbnail");
		let total = $('.product-gallery--navigation .product-gallery--media-thumbnail').length - 1;

		if(currentThumb >= total) {
			$('.ico-right-arrow').addClass('hide');
			$('.ico-left-arrow').removeClass('hide');
		} else if(currentThumb == 0){
			$('.ico-right-arrow').removeClass('hide');
			$('.ico-left-arrow').addClass('hide');
		} else {
			$('.ico-right-arrow').removeClass('hide');
			$('.ico-left-arrow').removeClass('hide');
		}

	});

}



//
// Newsletter Popup (using mailchimp now)
// let popup = localStorage.getItem('popup');

// let onScroll = function() {
// 	let st = $(this).scrollTop();
// 	if (popup === null && $('.template-index').length) {
// 		lastScrollTop = st;
// 		if (st >= 500) {
// 			$('.newsletter-popup').fadeIn();
// 			localStorage.setItem('popup', 1);
// 			popup = true;
// 		}
// 	}
// }
// onScroll();
// $(window).scroll(onScroll);

// var mc1Submitted = false;
// $('#mc-embedded-subscribe-form').on('submit reset', function (event) {
// 	console.log(event);
// 		if ("submit" === event.type) {
// 		mc1Submitted = true;
// 		} else if ( "reset" === event.type && mc1Submitted ) {

// 			$('.mc-field-group').css('display','none');
// 			$('#mc-embedded-subscribe').css('display','none');
// 			$('.description').css('display','none');
// 		}
// });


// $(document).on('click', '.newsletter-popup-close', function(e){
// 	e.preventDefault();
// 	$('.newsletter-popup').fadeOut();
// });



$('.product-options .option-select').on("click", function(){

 //$("select").click();

    console.log('clicked');
});


$('.modal-close').on("click", function(){
	$('.modal').fadeOut();

	$('.modal').removeClass('active');
	$('#size-guide').removeClass('active-plus');

});

$('#size-guide').on("click", function(){
	$('#size-guide-modal').addClass('visible');
});

// Size guide modal close functionality
$('.modal-close, #size-guide-modal').on('click', function(e) {
	if (e.target === this) {
		$('#size-guide-modal').removeClass('visible');
	}
});

// Prevent modal from closing when clicking inside the modal container
$('.modal-container').on('click', function(e) {
	e.stopPropagation();
});

$('.menu-toggle').on("click", function(e){
	e.preventDefault();

	// $('body').removeClass('sticky-announcement-bar');
	$('.mobile-nav-wrapper').toggleClass('visible');
	$('.site-mobile-nav').toggleClass('open');
	// $('html').toggleClass('scroll-locked');

	closeNav();
});

$('.mobile-nav-close').on("click", function(){
	$('.mobile-nav-wrapper').removeClass('visible');
	$('html').removeClass('scroll-locked');
	$('.site-mobile-nav').removeClass('open');
	$('.main-header').removeClass('header-nav-open');
	$('.main-header').addClass('header-layout-minimal');

});

function closeNav(){
	let container = $('.site-mobile-nav');
	if(container.hasClass("open")) {
		$(document).mouseup(function(e) {
			e.preventDefault();
				if (!container.is(e.target) && container.has(e.target).length === 0) {
					$('.mobile-nav-wrapper').removeClass('visible');
					$('.site-mobile-nav').removeClass('open');

					$('li.navmenu-item-parent .navmenu-submenu').removeClass('open');
					$('li.navmenu-item-parent').removeClass('open');
				}
		});
	}
}


// $(".navmenu-item-parent").hover(
//   function() {
// 		$('ul.navmenu-submenu').removeClass('open');
// 		$(this).children('ul').addClass('open');
//   }, function() {
// 		$('ul.navmenu-submenu').removeClass('open');
// 		$(this).children('ul').removeClass('open');
//   }
// );

// $("a.navmenu-link-parent").click(function() {
// 	$(this).toggleClass('open');
// 	$(this).next('ul').toggleClass('open');
// });

// $("li.navmenu-item-parent a.navmenu-link-parent").click(function(e) {
// 	e.preventDefault();

// 	// if($('.navmenu-depth-3').hasClass('open')){
// 	// 	$(this).removeClass('open');
// 	// 	$(this).parent('li').removeClass('open');

// 	// 	$('.navmenu-depth-3.navmenu-submenu').removeClass('open');
// 	// 	console.log('removed');
// 	// } else {
// 	// 	if(!$(this).parents('li').hasClass('open')){
// 	// 		console.log('this');
// 	// 		$('li.navmenu-item-parent .navmenu-submenu').removeClass('open');
// 	// 		$('li.navmenu-item-parent').removeClass('open');

// 	// 		//$('.navmenu-depth-2 li.navmenu-item-parent').removeClass('open');
// 	// 	} else {
// 	// 		console.log('else');
// 	// 		$('.navmenu-depth-2 li.navmenu-item-parent').removeClass('open');
// 	// 		$('.navmenu-depth-3.navmenu-submenu').removeClass('open');
// 	// 		//console.log('else');
// 	// 	}

// 	// 	// add class to parent
// 	// 	$(this).parent('li').toggleClass('open');
// 	// 	$(this).next('ul.navmenu-submenu').toggleClass('open');
// 	// }


// 		if(!$(this).parents('li').hasClass('open')){
// 			$('li.navmenu-item-parent .navmenu-submenu').removeClass('open');
// 			$('li.navmenu-item-parent').removeClass('open');

// 			//$('.navmenu-depth-2 li.navmenu-item-parent').removeClass('open');
// 		} else {
// 			$('.navmenu-depth-2 li.navmenu-item-parent').removeClass('open');
// 			$('.navmenu-depth-3.navmenu-submenu').removeClass('open');
// 			//console.log('else');
// 		}

// 		// add class to parent
// 		$(this).parent('li').toggleClass('open');
// 		$(this).next('ul.navmenu-submenu').toggleClass('open');

// });


// $('a').on('click', function(){
// 	if(!$(this).parents().hasClass('open')){
// 			$('li').removeClass('open');
// 	}
// 	$(this).parent().addClass('open');
// });


$('.navmenu-depth-1 > li.navmenu-item-parent > a').click(function(e) {
	e.preventDefault();

	//$('.navmenu-depth-2 .navmenu-link-parent').removeClass('active');


	//$('.mobile-nav-wrapper .navmenu-depth-2').slideToggle();

	if($(this).parent().hasClass('active')) {
		console.log('Top Active');
		$('.navmenu-depth-1 .navmenu-item-parent').removeClass('active');
		$('.navmenu-depth-2').slideUp('fast');
		// Close everything
		$('.navmenu-depth-2 .navmenu-item-parent').removeClass('active');
		$('.navmenu-depth-2 .navmenu-link-parent').removeClass('active');
		$('.navmenu-depth-3').slideUp('fast');

	} else {
		$('.navmenu-depth-1 .navmenu-item-parent').removeClass('active');
		$('.navmenu-depth-2').slideUp('fast');
		// Close everything
		$('.navmenu-depth-2 .navmenu-item-parent').removeClass('active');
		$('.navmenu-depth-2 .navmenu-link-parent').removeClass('active');
		$('.navmenu-depth-3').slideUp('fast');

		$(this).parent().toggleClass('active');
		$(this).next('.navmenu-depth-2').slideToggle('fast');
		console.log('Top Not');
	}

});

$('.navmenu-depth-2 .navmenu-item-parent > a').click(function(e) {
	e.preventDefault();

	if($(this).hasClass('active')) {
		console.log('active');
		$(this).removeClass('active');
		$(this).parent().removeClass('active');
		$(this).next().slideUp('fast');
	} else {
		console.log('not');

		// Remove active
		$('.navmenu-depth-2 .navmenu-item-parent').removeClass('active');
		$('.navmenu-depth-2 .navmenu-link-parent').removeClass('active');
		$('.navmenu-depth-3').slideUp('fast');

		$(this).addClass('active');
		$(this).parent().addClass('active');
		$(this).next().slideDown('fast');
	}

});



if($('.featured-products-slider').length) {
	$('.featured-products-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		dots: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					dots: false,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
}

if($('#shopify-section-recently-viewed').length) {
	$('#shopify-section-recently-viewed').hide();
}

if($('.template-product').length) {
	function productCheckHeight() {
		var checkerHight = $('#shopify-section-page-product, #shopify-section-page-product-contact').height();
		$('.page-header .sq-background').css('height',checkerHight + 105);
		//console.log(checkerHight);
	}

	$(window).resize(function() {
		productCheckHeight();
	});

	$(window).trigger('resize');

	$('.ac-container label').click(function(){
		setTimeout(function(){ 
			productCheckHeight();
		}, 500);
		//console.log('fired');
	});
}

setTimeout(function(){
	if($('#shopify-section-page-product, #shopify-section-page-product-contact').length) {
		productCheckHeight();
	}
}, 1000);

  /*!
   * Accordion toggle
   */
$(".ac-container label").click(function(){
	let current = $(this).next();

	if($(current).hasClass('active')) {
		$(this).next().removeClass('active');
		$(this).removeClass('active-plus');
	} else {
		$('.ac-container .inner').removeClass('active');
		$('.ac-container label').removeClass('active-plus');
		$(this).next().addClass('active');
		$(this).addClass('active-plus');
	}
});


  /*!
   * Videos
   */
if($('#video').length) {
	$('.featured-video__play').on('click', function(ev) {
		$('.featured-video__video').addClass('video-active');
		$("#video")[0].src += "&autoplay=1";
		ev.preventDefault();
	});
}


if($('.template-index').length) {
	$(window).scroll(function(){
		var scroll = $(window).scrollTop();

		// if($('body').hasClass('sticky-announcement-bar')){
		if (scroll >= 30) {
			$('.header-logo-desktop').css('opacity', '0');
			$('.gif-logo').css('opacity', '1');
		} else {

			$('.header-logo-desktop').css('opacity', '1');
			$('.gif-logo').css('opacity', '0');
		}
	});
}


$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});





$('.filter-menu').on("click", function(){
	$('.sb-widget').toggleClass('visible');
});

$('.filter-close').on("click", function(){
	$('.sb-widget').removeClass('visible');
});

$( document ).ready(function() {
	// jQuery('.advanced-filter').each(function() {
	// 		var el = jQuery(this)
	// 				,group = el.data('group');

	// 		if ( el.hasClass('active-filter') ) { //Remove class hidden
	// 			console.log(el);

	// 			el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
	// 		}
	// 		console.log('dvanced-filter first');
	// });




	// jQuery('.advanced-filter a').on('click', function(e) {

	// 	$(this).parent().toggleClass('active-filter');
	// 	console.log('fired active');
	// });




	// jQuery('.advanced-filter').on('click', function(e) {
	// 	e.preventDefault();

	// 	 var   el = $(this),
	// 				 groupContainer = el.parent().data('group-container'),
	// 				 group = el.data('group'),
	// 				 url = el.find('a').attr('href');




	// 		Shopify.queryParams = {};


	// 		console.log(Shopify.queryParams);





	// 		console.log(el);
	// 		console.log(groupContainer);
	// 		console.log(group);
	// 		console.log(url + 'this s URL');

	// 	 	//Continue as normal if we're clicking on the active link
	// 	 	if ( el.parent().hasClass('active-filter') ) {

	// 			activeTag = $('.active-filter[data-group="'+ group +'"]');

	// 			console.log('if');
	// 			console.log(activeTag + 'active Tag');
	// 			console.log(group + 'group');
	// 			console.log(url);
	// 			el.parent().removeClass('active-filter');

	// 			if ( activeTag.data('group') === group ) {
	// 					e.preventDefault();
	// 					activeHandle = activeTag.data('handle') + '+';

	// 					// Create new URL without the currently active handle
	// 					url = url.replace(activeHandle, '');
	// 					$('.btn-filter').attr("href", url);
	// 				}

	// 		} else {


	// 			console.log('else');
	// 			el.parent().addClass('active-filter');
	// 			$('.btn-filter').attr("href", url);
	// 		}



	// 		// var _logic = jQuery(".active-filter");
	// 		// if( _logic ){
	// 		// 	console.log(activeTag + 'logic section');
	// 		// 	// Get active group link (unidentified if there isn't one)
	// 		// 	activeTag = $('.active-filter[data-group="'+ group +'"]');

	// 		// 	// If a tag from this group is already selected, remove it from the new tag's URL and continue
	// 		// 	if ( activeTag && activeTag.data('group') === group ) {
	// 		// 		e.preventDefault();
	// 		// 		activeHandle = activeTag.data('handle') + '+';

	// 		// 		// Create new URL without the currently active handle
	// 		// 		url = url.replace(activeHandle, '');

	// 		// 		window.location = url;
	// 		// 	}
	// 		// }
	//  });

	//  jQuery('.btn-filter').on('click', function(e) {

	// });
});





// $('select.product-select').on('change', function(e) {
// 	var select = e.target;
// 	var option = select.options[select.selectedIndex];
// 	var cartBtn = $('input.add-to-cart');

// 	if ($(option).hasClass('disabled')) {

// 		$(cartBtn).val('OUT OF STOCK');
// 		$(cartBtn).prop('disabled', true);
// 		$(cartBtn).addClass('disabled');

// 	} else {
// 		$(cartBtn).val('ADD TO BAG');
// 		$(cartBtn).prop('disabled', false);
// 		$(cartBtn).removeClass('disabled');
// 	}
// });


$( document ).ready(function() {

		// if ($('select.product-select').hasClass('disabled')) {

		// 	var cartBtn = $('input.add-to-cart');

		// 	$(cartBtn).val('OUT OF STOCK');
		// 	$(cartBtn).prop('disabled', true);
		// 	$(cartBtn).addClass('disabled');

		// } else {
		// 	$(cartBtn).val('ADD TO BAG');
		// 	$(cartBtn).prop('disabled', false);
		// 	$(cartBtn).removeClass('disabled');
		// }


	setTimeout(function() {
		$(".giftcard-price").find('.final-price').css('display','inline-block');
		$(".giftcard-price").find('.exemptify_clone').css('display','none !important');
	}, 1000);

	// setTimeout(function() {
	// 	bodyPadding();
	// }, 2000);

	// setTimeout(function() {
	// 	$('body').css('padding-top', '10px');
	// }, 600);


});


// Fix Square background position if banner is enabled
function backgroundPadding() {
	let background 			 = $('.page-title .sq-background'),
			singleBackground = $('.template-product .page-header .sq-background');

	if ($(window).width() < 714) {

		if($('.pxs-announcement-bar')[0]){
			if($('.template-product').length){
				$(singleBackground).css('top', '160px');
			} else {
				$(background).css('top', '173px');
			}
		} else {
			// $('body').css('padding-top', '156px');

			if($('.template-product').length){
				$(singleBackground).css('top', '110px');
			} else {
				$(background).css('top', '110px');
			}
		}

	} else {

		if($('.pxs-announcement-bar')[0]){
			if($('.template-product').length){
				$(singleBackground).css('top', '207px');
			} else {
				$(background).css('top', '207px');
			}
		} else {
			if($('.template-product').length){
				$(singleBackground).css('top', '160px');
			} else {
				$(background).css('top', '154px');
			}
		}

	}
}

if($('.pxs-announcement-bar')[0]){
	backgroundPadding();
}


// Fix overlay image shwoing through
function resizedw(){
	$('.product-list-item').each(function(){
		$(this).find('.primary-image').css('margin', '');
		$(this).find('.primary-image').css('margin', 'auto');
	});
}

var doit;
window.onresize = function(){
	clearTimeout(doit);
	doit = setTimeout(resizedw, 500);
};

function bodyPadding() {
	if ($(window).width() < 714) {
		if($('.pxs-announcement-bar')[0]){
			$('body').css('padding-top', '180px');
		} else {
			$('body').css('padding-top', '110px');
		}
	} else {
		if($('.pxs-announcement-bar')[0]){
			$('body').css('padding-top', '207px');
		} else {
			$('body').css('padding-top', '156px');
		}
	}
}

$(window).resize(function() {
	bodyPadding();
	backgroundPadding();
});


/* Product Tag Filters - Good for any number of filters on any type of collection page. */

// Shopify.queryParams = {};
// if (location.search.length) {
// 	for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
// 		aKeyValue = aCouples[i].split('=');
// 		if (aKeyValue.length > 1) {
// 			Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
// 		}
// 	}
// }
// let filter = jQuery('.filter__dropdown li');
// filter.click(function(e) {
// 	e.preventDefault();
// 	let val = $(this).attr('data-value');
// 	$(this).toggleClass('active');
// 	var newTags = [];
// 	var newURL = '';

// 	console.log(newTags);
// 	filter.each(function() {
// 		if ( jQuery(this).hasClass('active') ) {
// 			newTags.push(val);
// 		}
// 	});
// 	if (newTags.length) {
// 		Shopify.queryParams.constraint = newTags.join('+');
// 	} else {
// 		delete Shopify.queryParams.constraint;
// 	}
// 	location.search = jQuery.param(Shopify.queryParams);
// });






// /* Product Tag Filters - Good for any number of filters on any type of collection page. */
// Shopify.queryParams = {};
// if (location.search.length) {
// 	for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
// 		aKeyValue = aCouples[i].split('=');
// 		if (aKeyValue.length > 1) {
// 			Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
// 		}
// 	}
// }
// let filters = jQuery('.filter__dropdown li.active');
// let filter = jQuery('.filter__dropdown li');
// filter.click(function(e) {
// 	e.preventDefault();
// 	let val = $(this).attr('data-value');
// 	$(this).toggleClass('active');
// 	var newTags = [];
// 	var newURL = '';

// 	console.log(newTags);
// 	console.log(newURL);

// 	filters.each(function() {
// 		if ( val != '') {
// 			newTags.push(val);
// 		}
// 	});
// 	if (newTags.length) {
// 		Shopify.queryParams.constraint = newTags.join('+');
// 	} else {
// 		delete Shopify.queryParams.constraint;
// 	}
// 	console.log(Shopify.queryParams);
// 	//location.search = jQuery.param(Shopify.queryParams);
// });




// $('.navmenu-link-parent').on('click', function(){
// 	$('ul.navmenu-submenu').removeClass('open');
// 	$(this).next('ul').toggleClass('open');
// });


// Loadmore pagination
$('.js-load-more').on('click', function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('.spinner').removeClass('hide');
  currentPage = currentPage+1;
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){

			if($('body').hasClass('template-blog')) {
				$('.blog-posts').append($(responseHTML).find('.blog-posts').html());
				console.log('blkock');
			} else {
				$('#product-list').append($(responseHTML).find('#product-list').html());
			}
			window.addEventListener('load', AOS.refresh);
    },
    complete: function() {
			console.log(currentPage);
			console.log(totalPages);

      if(currentPage < totalPages) {
				 $this.attr('disabled', false); 
				 $this.find('[load-more-text]').removeClass('hide'); 
				 $this.find('.spinner').addClass('hide');
			} else {
				$this.find('.spinner').addClass('hide');
			}

    }
  })
});

if($('.next-url').length) {
	let morePages = $('.next-url').val();

	if(!morePages ) {
		$('.js-load-more').hide();
		console.log('hide');
	}
}

// function removeDisable() {
// 	$('select.single-option-selector option' ).each(function(){
// 		if ($(this).is(":disabled")){
// 			$(this).removeAttr("disabled");
// 			$(this).addClass("disabled");
// 		}
// 	});
// }

// Remove disabled attribute
// if($('.product__options').length) {
// 	//hide any single option selectors
// 	// setTimeout(function() {
// 	// 	removeDisable();
// 	// }, 2000);
// }

$('select.single-option-selector').on('change', function(e) {
	// setTimeout(function() {
	// 	removeDisable();
	// }, 100);

	var select = e.target;
	var option = select.options[select.selectedIndex];
	var cartBtn = $('input.add-to-cart');

	if ($(option).hasClass('disabled')) {

		$(cartBtn).val('OUT OF STOCK');
		$(cartBtn).prop('disabled', true);
		$(cartBtn).addClass('disabled');

	} else {
		$(cartBtn).val('ADD TO BAG');
		$(cartBtn).prop('disabled', false);
		$(cartBtn).removeClass('disabled');
	}
});


// Variant button functionality
$('.variant-button').on('click', function(e) {
	e.preventDefault();
	
	var $button = $(this);
	var optionIndex = $button.data('option-index');
	var value = $button.data('value');
	
	// Remove selected class from other buttons in the same option group
	$button.siblings('.variant-button').removeClass('selected');
	
	// Add selected class to clicked button
	$button.addClass('selected');
	
	// Update the corresponding hidden select
	var $select = $button.closest('.variant-buttons-wrapper').find('.single-option-selector');
	$select.val(value).trigger('change');
	
	console.log('Variant button clicked:', value);
});

// // URL FIX
// (function () {
//   var keys = ['_pos','_sid','_ss'];
//   var deleteRegex = new RegExp(keys.join('=|') + '=')

//   var params = location.search.slice(1).split('&')
//   var search = []
//   for (var i = 0; i < params.length; i++) if (deleteRegex.test(params[i]) === false) search.push(params[i])

//   window.history.replaceState({}, document.title, location.pathname + (search.length ? '?' + search.join('&') : '') + location.hash)
// })();